export default "__VITE_ASSET__B_DcN$_Y__"